import React, { useState, useEffect } from "react";
import StackedBarChart from "../../atoms/StackedBarChart";
import "./managedmonthlyincomemodal.scss";
import { Card, Col, Row } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import ShadedLineChart from "../../atoms/ShadedLineChart";
import CustomSwitch from "../../atoms/CustomSwitch";
import { addCommas } from "../../helpers/helpers";
import { Link } from "react-router-dom";

const ManagedMonthlyIncomeModal = (props) => {
  const [cautiousBackground, setCautiousBackground] = useState(false);
  const [mediumBackground, setMediumBackground] = useState(true);
  const [optimisticBackground, setOptimisticBackground] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [percent, setPercent] = useState(5);
  const [mouseEnter, setMouseEnter] = useState(false); // eslint-disable-line
  const [lineChartTitle, setLineChartTitle] = useState(
    "The self-managed option", //eslint-disable-line
  );
  const [barChartTitle, setBarChartTitle] = useState("The self-managed option");
  const [remainingAmount, setremainingAmount] = useState(0);
  const [takenAmount, settakenAmount] = useState(0);
  const onSwitchAction = () => {
    setIsSwitchOn(!isSwitchOn);
  };
  const cautiousClicked = () => {
    setCautiousBackground(true);
    setMediumBackground(false);
    setOptimisticBackground(false);
  };
  const mediumClicked = () => {
    setCautiousBackground(false);
    setMediumBackground(true);
    setOptimisticBackground(false);
  };
  const optimisticClicked = () => {
    setCautiousBackground(false);
    setMediumBackground(false);
    setOptimisticBackground(true);
  };
  useEffect(() => {
    setCautiousBackground(false);
    setMediumBackground(true);
    setOptimisticBackground(false);
    if (props?.activeChart === "flexi") {
      setIsSwitchOn(true);
      setLineChartTitle("The self-managed option, flexi-access");
      setBarChartTitle("The self-managed option, flexi-access");
      setremainingAmount(
        props?.flexiIncomechartData &&
          props?.flexiIncomechartData?.remainingAmount, //eslint-disable-line
      );
      props?.isAnnaulSwitchOn
        ? settakenAmount(
            props?.flexiData &&
              props?.flexiData?.selfManagedFlexiAccessDrawdownAnnually, //eslint-disable-line
          )
        : settakenAmount(
            props?.flexiData &&
              props?.flexiData?.selfManagedFlexiAccessDrawdownMonthly, //eslint-disable-line
          );
    }
    if (props?.activeChart === "manage") {
      setIsSwitchOn(false);
      setBarChartTitle("Managed monthly income");
      setremainingAmount(
        props?.incomeData && props?.incomeData?.remainingAmount, //eslint-disable-line
      );
      props?.isAnnaulSwitchOn
        ? settakenAmount(props?.incomeData && props?.incomeData?.perYearValue)
        : settakenAmount(props?.incomeData && props?.incomeData?.perMonthValue);
    }
    if (props?.activeChart === "annuity") {
      setIsSwitchOn(false);
      setBarChartTitle("Monthly managed income, followed by annuity");
      setremainingAmount(
        props?.annuityData && props?.annuityData?.remainingAmount, //eslint-disable-line
      );
      props?.isAnnaulSwitchOn
        ? settakenAmount(props?.annuityData && props?.annuityData?.perYearValue)
        : settakenAmount(
            props?.annuityData && props?.annuityData?.perMonthValue, //eslint-disable-line
          );
    }
  }, []);
  useEffect(() => {
    if (mediumBackground === true) {
      setPercent(5);
    }
    if (cautiousBackground === true) {
      setPercent(2);
    }
    if (optimisticBackground === true) {
      setPercent(8);
    }
  }, [cautiousBackground, mediumBackground, optimisticBackground]);
  return (
    <div
      onMouseEnter={() => {
        setMouseEnter(true);
      }}
      className="parent-monthly-div"
    >
      <Row>
        <Col>
          <div className="mmi-small-close">
            <Link>
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      {isSwitchOn === false && (
        <>
          <Row>
            <Col className="mmi-title">
              <div>{barChartTitle}</div>
            </Col>
          </Row>
          <Row className="sub-heading-monthly">
            {props?.activeChart === "flexi" ? (
              <Col>
                Including the pots and cash lump sum that you&apos;ve selected,
                you are estimated to have a value of{" "}
                <span className="amt-bold">{`£${addCommas(
                  remainingAmount && remainingAmount?.toFixed(2), //eslint-disable-line
                )}`}</span>{" "}
                available for flexi-access income. We estimate that if you took
                a starting income of{" "}
                <span className="amt-bold">{`£${addCommas(
                  takenAmount && takenAmount?.toFixed(2), //eslint-disable-line
                )}`}</span>{" "}
                a {`${props?.isAnnaulSwitchOn ? "year" : "month"}`}, your pot
                will last until age{" "}
                <span className="amt-bold">{` ${props?.flexiIncomechartData?.age}`}</span>
                .
              </Col>
            ) : (
              <Col>
                Including the pots and cash lump sum that you&apos;ve selected,
                you are estimated to have a value of{" "}
                <span className="amt-bold">{`£${addCommas(
                  remainingAmount && remainingAmount?.toFixed(2), //eslint-disable-line
                )}`}</span>{" "}
                available for managed monthly income. TPT would manage your
                income so that your pot lasts until age
                <span className="amt-bold">{` ${props?.flexiIncomechartData?.age}`}</span>{" "}
                and your estimated starting income would be{" "}
                <span className="amt-bold">{`£${addCommas(
                  takenAmount && takenAmount?.toFixed(2), //eslint-disable-line
                )}`}</span>{" "}
                a {`${props?.isAnnaulSwitchOn ? "year" : "month"}`}.
              </Col>
            )}
          </Row>
          <Card className="card-parent">
            <div className="d-flex flex-row justify-content-between">
              <div className="parent-graph-div">
                {props?.activeChart === "flexi" ? (
                  <span className="head-text-2">
                    <span
                      className="circle"
                      style={{ backgroundColor: "#008500" }}
                    ></span>
                    DB pension
                  </span>
                ) : (
                  ""
                )}
                <span className="head-text-2">
                  <span
                    className="circle"
                    style={{ backgroundColor: "#151f6d" }}
                  ></span>
                  State pension
                </span>
                <span className="head-text-1">
                  <span
                    className="circle"
                    style={{ backgroundColor: "#a51890" }}
                  ></span>
                  DC income
                </span>
              </div>
              {props?.activeChart === "flexi" && (
                <span className="toggle-div mt-1">
                  <span className="income">Income</span>
                  <CustomSwitch
                    onColor="#a51890"
                    isOn={isSwitchOn}
                    handleToggle={onSwitchAction}
                  />
                  <span className="pot">Pot value</span>
                </span>
              )}
            </div>
            <StackedBarChart
              flexi={props?.flexiIncomechartData}
              manage={props?.IncomechartData}
              annuity={props?.AnnuitychartData}
              activeChart={props?.activeChart}
              spSwitch={props?.spSwitch}
              incomeData={props?.incomeData}
              annuityData={props?.annuityData}
            />
          </Card>
          <Row className="note">
            <Col>
              Please note, this tool is for illustration purposes only and is
              not financial advice.
            </Col>
          </Row>
          <Row className="understanding-your-graph">
            <Col>Understanding your graph</Col>
          </Row>
          <Row className="description-text">
            <Col>
              {props?.activeChart === "flexi"
                ? "Flexi-access allows you to decide how much income to take and how often. You will need to manage it so that it lasts as long as you need it to."
                : "The aim of Managed income is that it keeps up with inflation over time, so it continues to have the same current value. This is why income is presented as a level line."}
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              {" "}
              {props?.activeChart === "flexi"
                ? "We assume that payments will keep up with inflation over time, so it continues to have the same current value each year."
                : "[If 100% managed income] You&apos;ll need to rely fully on Managed income, as no other benefits are payable or have been selected."}
            </Col>
          </Row>{" "}
          <Row className="description-text">
            <Col>
              {" "}
              {props?.activeChart === "flexi"
                ? "If you toggle state pension ‘on’ in this calculator, we have assumed that you would reduce the income taken from your pot because you receive the state pension. This means that your drawdown would last longer."
                : "If you haven&apos;t yet included the State Pension, you can recalculate your estimate and view the impact of State Pension on your future income."}{" "}
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              {" "}
              {props?.activeChart === "flexi"
                ? "Toggle the state pension ‘off’ for an estimate without the state pension supplementing your income."
                : "Note that other DC pensions included in this modeller would need to be transferred to TPT to access the full estimated income from this option, otherwise only the income from your TPT pension would be payable."}
            </Col>
          </Row>
        </>
      )}
      {isSwitchOn === true && props?.activeChart === "flexi" && (
        <>
          <Row>
            <Col className="mmi-title">
              <div>{lineChartTitle}</div>
            </Col>
          </Row>
          <Row className="sub-heading-monthly">
            <Col>
              Including the pots and cash lump sum that you&apos;ve selected,
              you are estimated to have a value of{" "}
              <span className="amt-bold">{`£${addCommas(
                props?.flexiLinechartData &&
                  props?.flexiLinechartData?.remainingAmount?.toFixed(2), //eslint-disable-line
              )}`}</span>{" "}
              available for flexi-access income. We estimate that if you took a
              starting income of{" "}
              <span className="amt-bold">{`£${addCommas(
                takenAmount && takenAmount?.toFixed(2), //eslint-disable-line
              )}`}</span>{" "}
              a {`${props?.isAnnaulSwitchOn ? "year" : "month"}`}, your pot will
              last until age{" "}
              <span className="amt-bold">{` ${props?.flexiLinechartData?.age}`}</span>
              .
            </Col>
          </Row>
          <Card className="line-card-parent">
            <div className="line-parent-graph-div">
              <span className="line-head-text-1">Future growth estimate</span>
              <span className="line-head-text-2">{percent}%</span>
              <span className="cautious-button">
                <Buttons
                  name="Low"
                  className="turquoise"
                  variantname="icon-sixteen-px"
                  style={{
                    backgroundColor: cautiousBackground ? "#8deed6" : "#fff",
                  }}
                  handleClick={cautiousClicked}
                ></Buttons>
              </span>
              <span className="medium-button">
                <Buttons
                  name="Medium"
                  className="turquoise"
                  variantname="icon-sixteen-px"
                  style={{
                    backgroundColor: mediumBackground ? "#8deed6" : "#fff",
                  }}
                  handleClick={mediumClicked}
                ></Buttons>
              </span>
              <span className="optimistic-button">
                <Buttons
                  name="High"
                  className="turquoise"
                  variantname="icon-sixteen-px"
                  style={{
                    backgroundColor: optimisticBackground ? "#8deed6" : "#fff",
                  }}
                  handleClick={optimisticClicked}
                ></Buttons>
              </span>
              <span className="toggle-div mt-1">
                <span className="income">Income</span>
                <CustomSwitch
                  onColor="#a51890"
                  isOn={isSwitchOn}
                  handleToggle={onSwitchAction}
                />
                <span className="pot">Pot value</span>
              </span>
            </div>
            <ShadedLineChart
              data={props?.flexiLinechartData}
              cautious={cautiousBackground}
              medium={mediumBackground}
              optimistic={optimisticBackground}
            />
          </Card>
          <Card className="line-card-parent-sm">
            <Col className="toggle-div-sm mt-4 mb-4">
              <span className="income-sm">Income</span>
              <CustomSwitch
                onColor="#a51890"
                isOn={isSwitchOn}
                handleToggle={onSwitchAction}
              />
              <span className="pot-sm">Pot value</span>
            </Col>
            <ShadedLineChart
              data={props?.flexiLinechartData}
              cautious={cautiousBackground}
              medium={mediumBackground}
              optimistic={optimisticBackground}
            />
            <div className="line-parent-graph-div-sm">
              <span className="text-one me-1">Future growth estimate</span>
              <span className="text-two">{percent}%</span>
            </div>
            <div className="buttons-sm mt-2 mb-4">
              <span className="cautious-button">
                <Buttons
                  name="Low"
                  className="turquoise"
                  variantname="icon-sixteen-px"
                  style={{
                    backgroundColor: cautiousBackground ? "#8deed6" : "#fff",
                  }}
                  handleClick={cautiousClicked}
                ></Buttons>
              </span>
              <span className="medium-button ms-3 me-3">
                <Buttons
                  name="Medium"
                  className="turquoise"
                  variantname="icon-sixteen-px"
                  style={{
                    backgroundColor: mediumBackground ? "#8deed6" : "#fff",
                  }}
                  handleClick={mediumClicked}
                ></Buttons>
              </span>
              <span className="optimistic-button">
                <Buttons
                  name="High"
                  className="turquoise"
                  variantname="icon-sixteen-px"
                  style={{
                    backgroundColor: optimisticBackground ? "#8deed6" : "#fff",
                  }}
                  handleClick={optimisticClicked}
                ></Buttons>
              </span>
            </div>
          </Card>
          <Row className="note">
            <Col>
              Please note, this tool is for illustration purposes only and is
              not financial advice.
            </Col>
          </Row>
          <Row className="understanding-your-graph">
            <Col>Understanding your graph</Col>
          </Row>
          <Row className="description-text">
            <Col>
              <span
                className="circle"
                style={{ backgroundColor: "#a51890" }}
              ></span>{" "}
              <span className="head-bold">Savings period.</span> This is when
              your pension is being contributed to and ideally growing with
              time.
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              <span
                className="circle"
                style={{ backgroundColor: "#151f6d" }}
              ></span>{" "}
              <span className="head-bold">Cash lump sum.</span> It can look
              scary but this drop in value occurs when people take a lump sum of
              cash out of their savings pot at retirement age.
            </Col>
          </Row>{" "}
          <Row className="description-text">
            <Col>
              <span
                className="circle"
                style={{ backgroundColor: "#008500" }}
              ></span>{" "}
              <span className="head-bold">Drawdown period.</span> You may see a
              change of shape in the graph during drawdown.
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              {" "}
              A sharper drop in the early years indicates that you are initially
              using up more of your drawdown. For example, you rely on drawdown
              until you receive state pension or other income.
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              {" "}
              Once other income is payable, you will need less drawdown to give
              you the income that you need, so it will then also last longer.
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              {" "}
              In later years you may see a steeper section, this is when you
              don&apos;t have as much money left to draw upon so investment
              returns have a bigger impact.
            </Col>
          </Row>
          <Row className="description-text">
            <Col>
              <span
                className="circle"
                style={{ backgroundColor: "#41e2ba" }}
              ></span>{" "}
              <span className="head-bold">Projection estimates.</span> Based on
              our cautious, medium and optimistic outcomes, we expect your graph
              to be within this area.
            </Col>
          </Row>
        </>
      )}
      <div className="managed-button">
        {" "}
        <Buttons
          name="Close"
          className="primary"
          variantname="icon-sixteen-px"
          handleClick={props?.handleCloseButton}
        ></Buttons>
      </div>
    </div>
  );
};

export default ManagedMonthlyIncomeModal;
